"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var TableActionDelete_1 = require("../../../../../../../shared/components/table_actions/TableActionDelete");
var TableActionEdit_1 = require("../../../../../../../shared/components/table_actions/TableActionEdit");
var WrapTableActions_1 = require("../../../../../../../shared/components/table_actions/WrapTableActions");
var notificationHelper_1 = require("../../../../../../../shared/helpers/notificationHelper");
var ToolBarButtonsOnly_1 = require("../../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var menu_1 = require("antd/lib/menu");
var FontAwesome_1 = require("../../../../../../../shared/components/icons/FontAwesome");
var TableMenuIsLocked_1 = require("../../../../../../../shared/components/table_menus/TableMenuIsLocked");
var PlayerLevelOffersList = /** @class */ (function (_super) {
    __extends(PlayerLevelOffersList, _super);
    function PlayerLevelOffersList(props) {
        var _this = _super.call(this, props) || this;
        _this.columns = [
            {
                title: 'Уровень',
                dataIndex: _this.props.data.dk_app_language_id,
                key: _this.props.data.dk_app_language_id,
                width: 200,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, _this.props.rootRecord.title));
                }
            }, {
                title: 'Название',
                dataIndex: _this.props.data.dk_title,
                key: _this.props.data.dk_title,
                width: 200,
            }, {
                title: 'Язык',
                dataIndex: _this.props.data.dk_app_language_title,
                key: _this.props.data.dk_app_language_title,
                width: 200,
            }, {
                title: 'Приоритет',
                dataIndex: _this.props.data.dk_priority,
                key: _this.props.data.dk_priority,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(antd_1.Dropdown, { overlay: _this.getMoreActionsDropDownMenu(record), trigger: ['click'] },
                        React.createElement(antd_1.Button, { style: { width: 140, minWidth: 140, maxWidth: 140 } },
                            "\u041F\u0440\u0438\u043E\u0440\u0438\u0442\u0435\u0442-",
                            record.priority,
                            " ",
                            React.createElement(antd_1.Icon, { type: "down" }))));
                },
                width: 150,
            }, {
                title: 'Заблокирован',
                dataIndex: _this.props.data.dk_is_locked,
                key: _this.props.data.dk_is_locked,
                align: "center",
                render: function (text, record, idx) {
                    return (React.createElement(TableMenuIsLocked_1.default, { lockedTexts: { menu: "Заблокировать оффер", text: "Да" }, unlockedTexts: { menu: "Разблокировать оффер", text: "Нет" }, record: { key: record.key, title: record.title, locked: record.is_locked }, onLockClick: _this.doLockUnLockAction.bind(_this) }));
                },
                width: 150,
            }, {
                title: 'Добавлен',
                dataIndex: _this.props.data.dk_date_added,
                key: _this.props.data.dk_date_added,
                align: "center",
                width: 200,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_added.format(_this.props.state.getDateTimeFormat())));
                }
            }, {
                title: 'Действия',
                key: 'action',
                align: "center",
                render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                    React.createElement(TableActionEdit_1.default, { hint: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C", onClick: function () { _this.onEditPlayerClick(record); } }),
                    React.createElement(TableActionDelete_1.default, { hint: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C", confirmText: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u0443 \u0437\u0430\u043F\u0438\u0441\u044C ?", onClick: function () { _this.onDeleteClick(record); } }))); },
                width: 100
            }
        ];
        return _this;
    }
    PlayerLevelOffersList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0
        }, function () {
            _this.props.data.LoadData(_this.props.rootRecord.key);
        });
    };
    PlayerLevelOffersList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    PlayerLevelOffersList.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize
            }, function () {
                nextProps.data.LoadData(_this.props.rootRecord.key);
            });
        }
    };
    PlayerLevelOffersList.prototype.doLockUnLockAction = function (Key, Title, Lock) {
        this.props.data.SetIsLocked(Key, Lock, function () {
            if (Lock) {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u041E\u0444\u0444\u0435\u0440 \u0443\u0440\u043E\u0432\u043D\u044F ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u0437\u0430\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D"));
            }
            else {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u041E\u0444\u0444\u0435\u0440 \u0443\u0440\u043E\u0432\u043D\u044F ",
                    React.createElement("b", null,
                        "[",
                        Title,
                        "]"),
                    " \u0440\u0430\u0437\u0431\u043B\u043E\u043A\u0438\u0440\u043E\u0432\u0430\u043D"));
            }
        });
    };
    PlayerLevelOffersList.prototype.getLevelsArray = function () {
        var _ret = [];
        for (var i = 1; i <= 10; i++) {
            _ret.push(React.createElement(menu_1.default.Divider, { key: i + 100 }));
            _ret.push(React.createElement(menu_1.default.Item, { key: "" + i },
                React.createElement(FontAwesome_1.FA, { icon: "level-down-alt", left: true }),
                "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C ",
                i,
                " \u043F\u0440\u0438\u043E\u0440\u0438\u0442\u0435\u0442 "));
        }
        return _ret;
    };
    PlayerLevelOffersList.prototype.getMoreActionsDropDownMenu = function (record) {
        var _this = this;
        return (React.createElement(menu_1.default, { onClick: function (e) { _this.doMorection(e, record); } }, this.getLevelsArray()));
    };
    PlayerLevelOffersList.prototype.doMorection = function (e, record) {
        var _this = this;
        var _level = 1;
        _level = parseInt(e.key, 10);
        this.props.data.SetPriority(record.key, _level, function () {
            _this.props.data.LoadData(_this.props.rootRecord.key, function () {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u041F\u0440\u0438\u043E\u0440\u0438\u0442\u0435\u0442 \u0434\u043B\u044F \u043E\u0444\u0444\u0435\u0440\u0430 [",
                    record.title,
                    "] \u0438\u0437\u043C\u0435\u043D\u0435\u043D !"));
            });
        });
    };
    PlayerLevelOffersList.prototype.onEditPlayerClick = function (record) {
        if (this.props.onEditClick) {
            this.props.onEditClick(record);
        }
    };
    PlayerLevelOffersList.prototype.onDeleteClick = function (record) {
        this.props.data.DeleteData(record.key, function () {
            notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                "\u041F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435 ",
                React.createElement("b", null,
                    "[",
                    record.title,
                    "]"),
                " \u0431\u044B\u043B\u043E \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0443\u0434\u0430\u043B\u0435\u043D\u043E"));
        });
    };
    PlayerLevelOffersList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        this.setState({ pageNum: _page, pageSize: PageSize }, function () {
            if (_this.props.onPageConfigChanged) {
                _this.props.onPageConfigChanged(_page, PageSize);
            }
        });
    };
    PlayerLevelOffersList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.props.data.LoadData(this.props.rootRecord.key);
        }
        if (action === "create") {
            if (this.props.onNewClick) {
                this.props.onNewClick();
            }
        }
        if (action === "back") {
            if (this.props.onGoBack) {
                this.props.onGoBack();
            }
        }
    };
    PlayerLevelOffersList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { create: "Создать", refresh: "Обновить", back: "Назад" }, onClick: this.onToolBarClick.bind(this) }),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.columns, dataSource: this.state.data, pagination: {
                    pageSize: this.state.pageSize,
                    showSizeChanger: true,
                    current: this.state.pageNum,
                    total: this.state.totalRows,
                    position: "bottom",
                    onChange: this.onPageChanged.bind(this),
                    onShowSizeChange: this.onPageChanged.bind(this),
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 : ",
                        data.length,
                        " \u0438\u0437 ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0421\u043E\u0437\u0434\u0430\u043D:"),
                            " [",
                            record.date_added.format(_this.props.state.getDateTimeFormat()),
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D:"),
                            " [",
                            record.date_changed.format(_this.props.state.getDateTimeFormat()),
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u041F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0435:"),
                            " [",
                            record.offer_text,
                            "]")));
                }, scroll: { x: true } })));
    };
    return PlayerLevelOffersList;
}(React.Component));
exports.default = PlayerLevelOffersList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_player_levels/ui/component/cfg_offers/PlayerLevelOffersList.tsx
// module id = 1956
// module chunks = 0